import React, { useEffect, useState } from 'react';
import { api, fileUrl } from '@/lib/api';
import ImageUploader from '@/admin/ImageUploader';
import { TextField, Section, Row, SaveBar } from '@/admin/AdminUI';

export default function FeaturedSessionTab() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get('/admin/featured-session').then((r) => setData(r.data || {}));
  }, []);

  if (!data) return <div className="font-body text-ink-muted">Loading…</div>;

  const setSpeaker = (i, k, v) => {
    const speakers = [...(data.speakers || [])];
    speakers[i] = { ...speakers[i], [k]: v };
    setData({ ...data, speakers });
  };
  const ensureFour = () => {
    const speakers = [...(data.speakers || [])];
    while (speakers.length < 4) speakers.push({ name: '', title: '', photo: '' });
    return speakers.slice(0, 4);
  };

  const save = async () => {
    setSaving(true); setSaved(false);
    try {
      const payload = { ...data, speakers: ensureFour() };
      await api.put('/admin/featured-session', payload);
      setSaved(true); setTimeout(() => setSaved(false), 2000);
    } finally { setSaving(false); }
  };

  const speakers = ensureFour();

  return (
    <div>
      <Section title="Featured Session">
        <Row>
          <TextField label="Eyebrow" value={data.eyebrow} onChange={(v) => setData({ ...data, eyebrow: v })} />
          <TextField label="Label" value={data.label} onChange={(v) => setData({ ...data, label: v })} />
        </Row>
        <TextField label="Session Title" value={data.title} onChange={(v) => setData({ ...data, title: v })} />
        <Row>
          <TextField label="Date / Time" value={data.datetime} onChange={(v) => setData({ ...data, datetime: v })} />
          <TextField label="Location" value={data.location} onChange={(v) => setData({ ...data, location: v })} />
        </Row>
      </Section>

      <Section title="4 Featured Speakers">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {speakers.map((s, i) => (
            <div key={i} className="p-4 border border-border-line rounded-sm bg-white space-y-3">
              <div className="font-display font-bold uppercase text-[12px] text-ink-muted">Speaker {i + 1}</div>
              <ImageUploader value={s.photo} onChange={(v) => setSpeaker(i, 'photo', v)} label="Photo" />
              <TextField label="Name" value={s.name} onChange={(v) => setSpeaker(i, 'name', v)} />
              <TextField label="Title" value={s.title} onChange={(v) => setSpeaker(i, 'title', v)} />
            </div>
          ))}
        </div>
      </Section>

      <Section title="Moderator">
        <div className="p-4 border border-border-line rounded-sm bg-white space-y-3 max-w-lg">
          <ImageUploader value={data.moderator?.photo} onChange={(v) => setData({ ...data, moderator: { ...(data.moderator || {}), photo: v } })} label="Photo" />
          <TextField label="Name" value={data.moderator?.name} onChange={(v) => setData({ ...data, moderator: { ...(data.moderator || {}), name: v } })} />
          <TextField label="Title" value={data.moderator?.title} onChange={(v) => setData({ ...data, moderator: { ...(data.moderator || {}), title: v } })} />
        </div>
      </Section>

      <SaveBar onSave={save} saving={saving} saved={saved} />
    </div>
  );
}
